import { render } from "./role-list.vue?vue&type=template&id=05900dd8&scoped=true&ts=true"
import script from "./role-list.vue?vue&type=script&lang=ts"
export * from "./role-list.vue?vue&type=script&lang=ts"

import "./role-list.vue?vue&type=style&index=0&id=05900dd8&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05900dd8"]])

export default __exports__